import { Link } from '@tanstack/react-router';
import { Button } from '@workspace/ui/components/button';
import { ArrowLeft, Home } from 'lucide-react';
import { m } from '~/paraglide/messages.js';

export function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-6 max-w-md mx-auto px-4">
        {/* 404 Number */}
        <div className="space-y-2">
          <h1 className="text-9xl font-bold text-primary">404</h1>
          <h2 className="text-2xl font-semibold text-foreground">
            {m['not_found.title']()}
          </h2>
        </div>

        {/* Description */}
        <p className="text-muted-foreground text-lg">
          {m['not_found.description']()}
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              {m['not_found.go_home']()}
            </Link>
          </Button>

          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="w-4 h-4 mr-2" />
            {m['not_found.go_back']()}
          </Button>
        </div>
      </div>
    </div>
  );
}
